import React, { useState, useEffect } from 'react';
import NavBars from '../Sidebar/Sidebar';
import './protected.css';
import { UserAuth } from "../../authContext";
import { db } from '../../firebase'; // Adjust this path based on your project structure
import { collection, addDoc, query, where, getDocs } from 'firebase/firestore';

const Request = () => {
    const { user } = UserAuth();
    const [items, setItems] = useState([]);
    const [formData, setFormData] = useState({
        productName: '',
        productLink: '',
        imageLink: '',
        quantity: 1,
        description: '',
    });
    const [pendingRequests, setPendingRequests] = useState([]);

    // Fetch pending requests from Firestore
    const fetchPendingRequests = async () => {
        if (user) {
            const q = query(collection(db, 'requests'), where('userId', '==', user.uid));
            const querySnapshot = await getDocs(q);
            const requests = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setPendingRequests(requests);
        }
    };

    useEffect(() => {
        fetchPendingRequests();
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleAddItem = () => {
        // Example of how to add an item to the 'items' array
        setItems(prevItems => [...prevItems, formData]);
        setFormData({
            productName: '',
            productLink: '',
            imageLink: '',
            quantity: 1,
            description: '',
        });
    };

    const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    if (!formData.productName || !formData.description || formData.quantity < 0) {
        alert("Please fill in all required fields.");
        return;
    }

    // Validate item fields
    for (let item of items) {
        if (!item.productName || item.quantity <= 0) {
            alert(`Please fill in all fields for ${item.productName}.`);
            return;
        }
    }

    // If validation passes, proceed to submit
    try {
        const purchaseRequestData = {
            projectTitle: formData.productName,
            description: formData.description,
            quantity: formData.quantity,
            items: items, // Array of items to be sent
            userId: user.uid,
            userEmail: user.email,
            timestamp: new Date(),
        };

        // Submit the data to Firebase (adjust the collection name as needed)
        await addDoc(collection(db, 'projectRequests'), purchaseRequestData);

        alert('Project Proposal Request submitted successfully!');

        // Reset form and items
        setFormData({
            productName: '',
            productLink: '',
            imageLink: '',
            quantity: 0,
            description: '',
        });
        setItems([]);
    } catch (error) {
        console.error("Error submitting project request:", error);
        alert('Failed to submit project request. Please try again.');
    }
};


    return (
        <div className="request-page">
            <div className="sidebar">
                <h2>Pending Purchase Requests</h2>
                {pendingRequests.length > 0 ? (
                    <ul className="pending-requests-list">
                        {pendingRequests.map((request) => (
                            <li key={request.id} className="pending-request-item">
                                <p><strong>Product:</strong> {request.productName}</p>
                                <p><strong>Quantity:</strong> {request.quantity}</p>
                                <p><strong>Description:</strong> {request.description}</p>
                                <a href={request.productLink} target="_blank" rel="noopener noreferrer">View Product</a>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No pending requests.</p>
                )}
            </div>

            <div className="content">
                <h1 className='request-header'>Purchase Request Form</h1>
                <form onSubmit={handleSubmit} className='request-form'>
                    <div className="request-form-group">
                        <label htmlFor="productName" className='request-label'>Product Name</label>
                        <input
                            type="text"
                            required
                            name="productName"
                            className='request-input'
                            value={formData.productName}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="request-form-group">
                        <label htmlFor="productLink" className='request-label'>Product Link (Optional)</label>
                        <input
                            type="url"
                            name="productLink"
                            className='request-input'
                            value={formData.productLink}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="request-form-group">
                        <label htmlFor="imageLink" className='request-label'>Image Link</label>
                        <input
                            type="url"
                            required
                            className='request-input'
                            name="imageLink"
                            value={formData.imageLink}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="request-form-group">
                        <label htmlFor="quantity" className='request-label'>Quantity</label>
                        <input
                            type="number"
                            required
                            className='request-input'
                            min="1"
                            name="quantity"
                            value={formData.quantity}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="request-form-group">
                        <label htmlFor="description" className='request-label'>Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            className='request-textarea'
                        />
                    </div>
                    <button type="submit" className='request-button'>Submit</button>
                </form>
            </div>
            <NavBars />
        </div>
    );
};

export default Request;
